export const SET_INFO_TAB_SECTIONS = 'info_tabs/SET_INFO_TAB_SECTIONS';

export const setInfoTabSections = payload => ({
  type: SET_INFO_TAB_SECTIONS,
  payload,
});
